var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68734 16.6666L1.6665 12.6458L5.68734 8.62498L6.56234 9.49998L4.0415 12.0208H10.6248V13.2708H4.0415L6.56234 15.7916L5.68734 16.6666ZM14.3123 11.375L13.4373 10.5L15.9582 7.97915H9.37484V6.72915H15.9582L13.4373 4.20831L14.3123 3.33331L18.3332 7.35415L14.3123 11.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.12712fa42eca3f126d4f817ed881663a.svg";
export { ForwardRef as ReactComponent };